import { getId } from '@/utils/temporaryHelper'

export const InitialBlockIds = {
  header: getId(),
  introduction: getId(),
  services: getId(),
  news: getId(),
  footer: getId(),
}
